import React, { useCallback, useEffect, useState } from "react";
import { Box, Flex, Input } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { RootReducer } from "RootReducer";
import {
  FetchOverviewReport,
  UpdateOverviewDateRanges,
} from "views/admin/default/action";
import moment from "moment";
import ComplexTable from "./components/ComplexTable";
import { columnsDataComplex } from "views/admin/installOverview/variables/columnsData";
import { DateRangePicker } from "react-date-range";
import { useOutsideClick } from "hooks/useOutsideClick";
import GamelightButton from "components/button";
import { useHistory } from "react-router-dom";

export default function InstallOverview() {
  const history = useHistory();
  const dispatch = useDispatch();

  const reportRequestState = useSelector(
    (state: RootReducer) => state.overview.fetchOverviewRequestState
  );
  const report = useSelector((state: RootReducer) => state.overview.report);
  const startDate = useSelector(
    (state: RootReducer) => state.overview.datepickerStartDate
  );
  const endDate = useSelector(
    (state: RootReducer) => state.overview.datepickerEndDate
  );

  const isReportSuccessful = reportRequestState.isSuccessful;

  const [ranges, setRanges] = useState({
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  });
  const [internalRanges, setInternalRanges] = useState({
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  });

  const [isDatePickerVisible, setDatePickerVisible] = useState(false);

  const handleClickOutside = useCallback(
    (internalRanges: any) => {
      if (isDatePickerVisible) {
        setRanges(internalRanges);
        setDatePickerVisible(false);
      }
    },
    [isDatePickerVisible]
  );

  const ref = useOutsideClick(handleClickOutside, internalRanges);

  const differentDates =
    internalRanges.startDate.toDateString() ==
    internalRanges.endDate.toDateString()
      ? 1
      : 2;
  const formattedDate =
    differentDates === 1
      ? moment(internalRanges.startDate).format("ll")
      : `${moment(internalRanges.startDate).format("ll")} - ${moment(
          internalRanges.endDate
        ).format("ll")}`;

  useEffect(() => {
    dispatch(FetchOverviewReport(ranges.startDate, ranges.endDate, "cpi"));
  }, [ranges.startDate, ranges.endDate]);

  let tableColumns = columnsDataComplex;

  return (
    <Flex flexDir={"column"} pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Flex alignSelf={"flex-end"} ref={ref} py={2} gap={2}>
        <GamelightButton
          onClick={() => {
            history.push("/ua/cpi/create");
          }}
        >
          {"Create CPI Campaign"}
        </GamelightButton>
        <Input
          borderRadius={8}
          onClick={() => {
            setInternalRanges(ranges);
            setDatePickerVisible(!isDatePickerVisible);
          }}
          style={{
            backgroundColor: "white",
            textAlign: "center",
            width: differentDates * 120 + 40,
          }}
          defaultValue={formattedDate}
          value={formattedDate}
        />

        {isDatePickerVisible && (
          <Box
            style={{
              position: "absolute",
              right: 20,
              zIndex: 200,
              top: 50,
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            }}
          >
            <DateRangePicker
              ranges={[internalRanges]}
              onChange={(newRanges: any) => {
                setInternalRanges({
                  endDate: newRanges.selection.endDate,
                  key: newRanges.selection.key,
                  startDate: newRanges.selection.startDate,
                });
                dispatch(
                  UpdateOverviewDateRanges(
                    newRanges.selection.startDate,
                    newRanges.selection.endDate
                  )
                );
              }}
            />
          </Box>
        )}
      </Flex>
      <ComplexTable
        isLoading={!isReportSuccessful}
        columnsData={tableColumns}
        tableData={report ? report.campaigns : []}
      />
    </Flex>
  );
}
